<template>
  <div class="mx-5 mt-5"><SelezioneMultipla :rotta_back="rotta_back" /></div>
</template>
<script>
import SelezioneMultipla from "@/views/PRODUCTION/SelezioneMultipla/SelezioneMultipla.vue";
export default {
  name: "SelezioneMultiplaPRODAdapter",
  components: {
    SelezioneMultipla,
  },
  props: {},
  data() {
    return {
      // Variabili d'appoggio
      rotta_back: "/home/production",

      // Modal

      // Array
    };
  },
  computed: {},
  watch: {
    variabile: {
      immediate: true,
      handler() {},
    },
  },
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style scoped>
</style>